import VueRecaptcha from 'vue-recaptcha'
import {required, email} from 'vuelidate/lib/validators'
import {mapActions, mapState} from 'vuex'

import config from '@/config'
import gaMixin from '@/mixins/ga'

import Heading from '@/components/heading/heading'
import Icon from '@/components/icon'

export default {
  mixins: [gaMixin],
  components: {
    'vue-recaptcha': VueRecaptcha,
    appHeading: Heading,
    appIcon: Icon
  },
  data() {
    return {
      email: '',
      phone: '',
      newsletter: false,
      siteKey: config.RECAPTCHA_SITE_KEY,
      token: null,
      isShown: false,
      isExited: false
    }
  },
  validations: {
    email: {
      required,
      email
    },
    phone: {
      required
    },
    token: {
      required
    }
  },
  computed: {
    ...mapState('contact', ['loading'])
  },
  methods: {
    ...mapActions('contact', ['contactUs']),
    ...mapActions('utils', ['openNotification', 'closeNotification']),
    initRecaptcha() {
      let script = document.createElement('script')
      script.src = config.RECAPTCHA_URL
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    },
    onVerify(response) {
      this.token = response
    },
    onExpired() {
      this.token = null
    },
    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.contactUs({
        email: this.email,
        phone: this.phone,
        source: 'exit-popup',
        newsletter: this.newsletter,
        token: this.token
      })
        .then(() => {
          this.openNotification({type: 'success', message: 'Thank you! Have a nice day!'})
          this.resetForm()
          this.sendEventGA('Exit Popup', 'Send Form', 'Sent')
        })
        .catch(() => {
          this.openNotification({type: 'error', message: 'Error :('})
          this.resetForm()
        })
    },
    resetForm() {
      setTimeout(() => {
        this.email = ''
        this.phone = ''
        this.newsletter = false
        this.token = null

        this.$v.$reset()
        this.$refs.recaptcha.reset()
        this.closeNotification()
        this.hide()
      }, 3000)
    },
    hide() {
      this.isShown = true;
      this.isExited = false;
      document.querySelector('html').classList.remove('scroll-hidden')
    },
    onExitPopup(obj, evt, fn) {
      if (obj.addEventListener) {
        obj.addEventListener(evt, fn, false)
      } else if (obj.attachEvent) {
        obj.attachEvent("on" + evt, fn)
      }
    }
  },
  mounted() {
    this.initRecaptcha()

    this.onExitPopup(document, 'mouseout', evt => {
      if (evt.toElement === null && evt.relatedTarget === null) {
        this.isExited = true

        if (!this.isShown) {
          document.querySelector('html').classList.add('scroll-hidden')
        }
      }
    })
  }
}
